import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  name: 'Marcelo G.',
  location: 'Puente Alto',
  result: '$9.5M CLP ahorrados en 90 días',
  text: "Debía 12 millones entre consumo y retail. Estaba desesperado y a punto de perder mi auto. Gracias al capítulo del 'Blindaje de Sueldo' logré rescatar mi sueldo del Banco Estado y a los 3 meses negocié mi deuda de CMR por solo 2.5 millones. ¡Me ahorré casi 10 palos!"
}, {
  name: 'Claudia S.',
  location: 'Concepción',
  result: 'Fin del acoso de cobranza en 48 horas',
  text: 'Lo que más me sirvió fueron las plantillas para el SERNAC. Me llamaban 10 veces al día, incluso a mi mamá. Mandé la carta que sale en el bono 2 y los llamados pararon en seco. Por fin volví a dormir tranquila.'
}, {
  name: 'Felipe R.',
  location: 'Santiago Centro',
  result: 'Limpieza de DICOM y nuevo arriendo',
  text: 'Pensé que por estar en DICOM por el CAE nunca podría arrendar un departamento digno. Apliqué el bono de Limpieza de Salud y Educación y en 3 días mi certificado de Equifax estaba limpio. ¡No lo podía creer!'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-navy-900" data-id="element-246">
      <div className="max-w-6xl mx-auto" data-id="element-247">
        <div className="text-center mb-16" data-id="element-248">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-249">
            Resultados Reales de{' '}
            <span className="text-gold-500" data-id="element-250">Chilenos Reales</span>
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-251">
            Personas que ya recuperaron su tranquilidad financiera
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-252">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-navy-800 p-8 rounded-2xl border border-navy-700 relative" data-id="element-253">
              <Quote className="absolute top-6 right-6 text-navy-700 w-12 h-12" data-id="element-254" />
              <div className="flex gap-1 mb-6" data-id="element-255">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold-500 text-gold-500" data-id="element-256" />)}
              </div>
              <p className="text-gray-300 italic mb-8 relative z-10" data-id="element-257">
                "{testimonial.text}"
              </p>
              <div className="border-t border-navy-700 pt-6" data-id="element-258">
                <p className="font-bold text-white" data-id="element-259">{testimonial.name}</p>
                <p className="text-sm text-gray-400 mb-2" data-id="element-260">
                  {testimonial.location}
                </p>
                <div className="inline-block bg-gold-500/10 text-gold-400 text-sm font-medium px-3 py-1 rounded-full" data-id="element-261">
                  Resultado: {testimonial.result}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}